import React, { memo, forwardRef } from 'react';
import cn from 'classnames';
import { FocusScope } from '@react-aria/focus';
import { useTheme } from '../ThemeProvider';
import { Opacity, Slide, TransitionGroup } from '../transitions';
import { Paper } from '../paper';
import { Overlay } from './Overlay';
import { Backdrop } from './Backdrop';
import { TRANSITION_DURATION } from './consts';
import { ModalContainer } from './ModalContainer';
import styles from './sidepanel.module.css';
const RTL_MAP = {
    left: 'right',
    right: 'left',
    top: 'top',
    bottom: 'bottom',
};
const Wrapper = forwardRef(function Wrapper({ children, opened, contain, autoFocus, restoreFocus, ...rest }, ref) {
    var _a, _b;
    // нужно, чтобы работала обертка в Slide
    const child = React.cloneElement(children, {
        ...children.props,
        ...rest,
        className: cn(rest.className, children.props.className),
        style: { ...((_a = rest.style) !== null && _a !== void 0 ? _a : {}), ...((_b = children.props.style) !== null && _b !== void 0 ? _b : {}) },
    });
    if (opened) {
        // отрабатывает только на маунт/анмаунт
        // сайдпанель бывает всегда замаунчена, а хочется сохранить поведение
        return (React.createElement(FocusScope, { contain: contain, autoFocus: autoFocus, restoreFocus: restoreFocus }, child));
    }
    return React.createElement(React.Fragment, null, child);
});
export const SidePanel = memo(forwardRef(function Modal({ children, Component = Paper, dismissable, onClose, opened, backdrop, direction, overlay, className, keepMount, portal, preventScroll, enableFocusOutside, disableAutoFocus, disableRestoreFocus, ...props }, ref) {
    const { dir } = useTheme();
    const finalDirection = dir !== 'rtl' ? direction : RTL_MAP[direction];
    return (React.createElement(TransitionGroup, { on: !!opened },
        React.createElement(Overlay, { portal: portal, dismissable: dismissable, opened: opened, onClose: onClose, ...overlay },
            React.createElement(Opacity, { duration: TRANSITION_DURATION },
                React.createElement(Backdrop, { ...(typeof backdrop === 'boolean' ? { visible: backdrop } : backdrop) })),
            React.createElement(Slide, { duration: TRANSITION_DURATION, direction: finalDirection, keepMount: keepMount },
                React.createElement(Wrapper, { autoFocus: !disableAutoFocus, contain: !enableFocusOutside, opened: opened, restoreFocus: !disableRestoreFocus },
                    React.createElement(ModalContainer, { Component: Component, className: cn(styles.sidePanel, className, styles[finalDirection]), preventScroll: keepMount && !opened ? false : preventScroll, ...props, ref: ref, "aria-hidden": !opened, 
                        // React не знает такого атрибута (выключает фокус на скрытом сайдбаре, даже если он замаунчен)
                        // пока слабая поддержка браузеров
                        // @ts-expect-error
                        inert: opened ? undefined : '' }, children))))));
}));
